import { Layout, Calendar } from "components"
export const SignalPlan = () => {
 return (
  <Layout>
   <Calendar />
  </Layout>
 )
}
